import React from "react";
import Markdown from "react-markdown";
import { ImageProvider } from "../../../utils/image-provider";
const AirportSec = ({ data }) => {
  const card = data.cards;
  return (
    <section className="container">
      <div className="gird grid-cols-1 mx-auto pt-[1.6vw]">
        <h2
          className="text-center text-[4.7vw] md:text-[2.38vw] font-redhatMedium mb-[1.2vw]"
          style={{ color: data.heading_color }}
        >
          {data.heading}
        </h2>
        <p
          className="text-center  font-redhatMedium text-[3.5vw] md:text-[1.34vw] "
          style={{ color: data.heading_color }}
        >
          {data?.description?.data?.description}
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-4 mx-auto ">
        {card.map((section, index) => (
          <div
            key={index}
            className=" p-[1.2vw] flex flex-col items-center text-center"
          >
            <div className=" flex justify-center imgCard">
              <ImageProvider
                className=""
                Image={section?.card_image}
                alt=""
                tailwindStyle={
                  "w-[90%] min-h-[28.44vh] z-[1000] md:w-[33.44vh] lg:w-[28.44vh] lg:min-h-[20.44vh] xl:w-[38.44vh] lg:min-h-[30.44vh] object-fill"
                }
              />
            </div>
            <div className="decsrption bg-[#F1F2F4] description">
              <h3
                className="text-[4.4vw] md:text-[1.6vw] font-redhatMedium "
                style={{ color: section.heading_color }}
              >
                {section.heading}
              </h3>
              <p className="text-[#667083] text-[3.5vw] md:text-[0.95vw]  font-redhatRegular">
                <Markdown>
                  {section.description?.data?.description || ""}
                </Markdown>
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AirportSec;
